/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InputCreateOffer } from '../models';
// @ts-ignore
import type { InputsendQRCodeOffer } from '../models';
// @ts-ignore
import type { ResponseConsumeOffer } from '../models';
// @ts-ignore
import type { ResponseConsumeRequest } from '../models';
// @ts-ignore
import type { ResponseCreateOffer } from '../models';
// @ts-ignore
import type { ResponseCreateRequest } from '../models';
// @ts-ignore
import type { ResponseSendQRCode } from '../models';
// @ts-ignore
import type { ResponseTestSSI } from '../models';
/**
 * SsiApi - axios parameter creator
 * @export
 */
export const SsiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Consume offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeOffer: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ssi/consume-offer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Consume request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeRequest: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ssi/consume-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create offer
         * @param {InputCreateOffer} [inputCreateOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffer: async (inputCreateOffer?: InputCreateOffer, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ssi/offer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputCreateOffer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRequest: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ssi/request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send q r code offer
         * @param {InputsendQRCodeOffer} [inputsendQRCodeOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendQRCodeOffer: async (inputsendQRCodeOffer?: InputsendQRCodeOffer, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ssi/send-qrcode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputsendQRCodeOffer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Test s s i
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSSI: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('testSSI', 'roomId', roomId)
            const localVarPath = `/ssi/consume-request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (roomId !== undefined) {
                localVarQueryParameter['roomId'] = roomId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SsiApi - functional programming interface
 * @export
 */
export const SsiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SsiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Consume offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consumeOffer(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseConsumeOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consumeOffer(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SsiApi.consumeOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Consume request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consumeRequest(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseConsumeRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consumeRequest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SsiApi.consumeRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create offer
         * @param {InputCreateOffer} [inputCreateOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOffer(inputCreateOffer?: InputCreateOffer, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCreateOffer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOffer(inputCreateOffer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SsiApi.createOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRequest(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCreateRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRequest(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SsiApi.createRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send q r code offer
         * @param {InputsendQRCodeOffer} [inputsendQRCodeOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendQRCodeOffer(inputsendQRCodeOffer?: InputsendQRCodeOffer, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSendQRCode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendQRCodeOffer(inputsendQRCodeOffer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SsiApi.sendQRCodeOffer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Test s s i
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testSSI(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTestSSI>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testSSI(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SsiApi.testSSI']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SsiApi - factory interface
 * @export
 */
export const SsiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SsiApiFp(configuration)
    return {
        /**
         * 
         * @summary Consume offer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeOffer(options?: RawAxiosRequestConfig): AxiosPromise<ResponseConsumeOffer> {
            return localVarFp.consumeOffer(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Consume request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consumeRequest(options?: RawAxiosRequestConfig): AxiosPromise<ResponseConsumeRequest> {
            return localVarFp.consumeRequest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create offer
         * @param {InputCreateOffer} [inputCreateOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOffer(inputCreateOffer?: InputCreateOffer, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCreateOffer> {
            return localVarFp.createOffer(inputCreateOffer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRequest(options?: RawAxiosRequestConfig): AxiosPromise<ResponseCreateRequest> {
            return localVarFp.createRequest(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send q r code offer
         * @param {InputsendQRCodeOffer} [inputsendQRCodeOffer] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendQRCodeOffer(inputsendQRCodeOffer?: InputsendQRCodeOffer, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSendQRCode> {
            return localVarFp.sendQRCodeOffer(inputsendQRCodeOffer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Test s s i
         * @param {string} roomId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testSSI(roomId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseTestSSI> {
            return localVarFp.testSSI(roomId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SsiApi - interface
 * @export
 * @interface SsiApi
 */
export interface SsiApiInterface {
    /**
     * 
     * @summary Consume offer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApiInterface
     */
    consumeOffer(options?: RawAxiosRequestConfig): AxiosPromise<ResponseConsumeOffer>;

    /**
     * 
     * @summary Consume request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApiInterface
     */
    consumeRequest(options?: RawAxiosRequestConfig): AxiosPromise<ResponseConsumeRequest>;

    /**
     * 
     * @summary Create offer
     * @param {InputCreateOffer} [inputCreateOffer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApiInterface
     */
    createOffer(inputCreateOffer?: InputCreateOffer, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCreateOffer>;

    /**
     * 
     * @summary Create request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApiInterface
     */
    createRequest(options?: RawAxiosRequestConfig): AxiosPromise<ResponseCreateRequest>;

    /**
     * 
     * @summary Send q r code offer
     * @param {InputsendQRCodeOffer} [inputsendQRCodeOffer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApiInterface
     */
    sendQRCodeOffer(inputsendQRCodeOffer?: InputsendQRCodeOffer, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSendQRCode>;

    /**
     * 
     * @summary Test s s i
     * @param {string} roomId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApiInterface
     */
    testSSI(roomId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseTestSSI>;

}

/**
 * SsiApi - object-oriented interface
 * @export
 * @class SsiApi
 * @extends {BaseAPI}
 */
export class SsiApi extends BaseAPI implements SsiApiInterface {
    /**
     * 
     * @summary Consume offer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApi
     */
    public consumeOffer(options?: RawAxiosRequestConfig) {
        return SsiApiFp(this.configuration).consumeOffer(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Consume request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApi
     */
    public consumeRequest(options?: RawAxiosRequestConfig) {
        return SsiApiFp(this.configuration).consumeRequest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create offer
     * @param {InputCreateOffer} [inputCreateOffer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApi
     */
    public createOffer(inputCreateOffer?: InputCreateOffer, options?: RawAxiosRequestConfig) {
        return SsiApiFp(this.configuration).createOffer(inputCreateOffer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApi
     */
    public createRequest(options?: RawAxiosRequestConfig) {
        return SsiApiFp(this.configuration).createRequest(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send q r code offer
     * @param {InputsendQRCodeOffer} [inputsendQRCodeOffer] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApi
     */
    public sendQRCodeOffer(inputsendQRCodeOffer?: InputsendQRCodeOffer, options?: RawAxiosRequestConfig) {
        return SsiApiFp(this.configuration).sendQRCodeOffer(inputsendQRCodeOffer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Test s s i
     * @param {string} roomId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SsiApi
     */
    public testSSI(roomId: string, options?: RawAxiosRequestConfig) {
        return SsiApiFp(this.configuration).testSSI(roomId, options).then((request) => request(this.axios, this.basePath));
    }
}

